import { mutateCachedFetch } from '@structural-climbing/auth'
import { competitionsCacheKey } from './useCompetitions'
import type { CompetitionSummary } from './types'

/**
 * Flip a competition's joined flag in the cached lists.
 *
 * The competitions list is cached with a stale window, so walking back to it
 * straight after joining showed the competition still sitting under "At my
 * gyms". Patching the cache is cheaper and steadier than forcing a refetch, and
 * the next revalidation confirms it against the server anyway.
 *
 * Both keys are patched: the global list, and the per-gym one the dashboard
 * teaser reads.
 */
export function markCompetitionJoined(
  competitionId: string,
  gymId: string | null | undefined,
  myGymIds: string[],
  joined: boolean,
): void {
  const patch = (list: CompetitionSummary[]) =>
    list.map((c) => (c.id === competitionId ? { ...c, joined } : c))

  // The cross-gym list the competitions page reads, and the single-gym one the
  // dashboard teaser reads. Both keys are built the same way, so a change to how
  // they are named cannot leave this patching a key nobody holds.
  mutateCachedFetch<CompetitionSummary[]>(competitionsCacheKey(myGymIds, 'all'), patch)
  if (gymId) mutateCachedFetch<CompetitionSummary[]>(competitionsCacheKey([gymId], 'gym'), patch)
}
